var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDifficult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 3C11.0001 2.44772 10.5524 2 10.0001 2C9.44784 2 9.00012 2.44772 9.00012 3V4C9.00012 4.55228 9.44784 5 10.0001 5C10.5524 5 11.0001 4.55228 11.0001 4V3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6569 5.75731C16.0475 5.36678 16.0475 4.73362 15.6569 4.34309C15.2664 3.95257 14.6332 3.95257 14.2427 4.34309L13.5356 5.0502C13.1451 5.44072 13.1451 6.07389 13.5356 6.46441C13.9261 6.85494 14.5593 6.85494 14.9498 6.46441L15.6569 5.75731Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 10C18.0001 10.5523 17.5524 11 17.0001 11H16.0001C15.4478 11 15.0001 10.5523 15.0001 10C15.0001 9.44771 15.4478 9 16.0001 9H17.0001C17.5524 9 18.0001 9.44771 18.0001 10Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05031 6.46443C5.44083 6.85496 6.074 6.85496 6.46452 6.46443C6.85505 6.07391 6.85505 5.44074 6.46452 5.05022L5.75742 4.34311C5.36689 3.95259 4.73373 3.95259 4.3432 4.34311C3.95268 4.73363 3.95268 5.3668 4.3432 5.75732L5.05031 6.46443Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00012 10C5.00012 10.5523 4.55241 11 4.00012 11H3.00012C2.44784 11 2.00012 10.5523 2.00012 10C2.00012 9.44771 2.44784 9 3.00012 9H4.00012C4.55241 9 5.00012 9.44771 5.00012 10Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 16V15H12.0001V16C12.0001 17.1046 11.1047 18 10.0001 18C8.89555 18 8.00012 17.1046 8.00012 16Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 14C12.0156 13.6597 12.2077 13.3537 12.4769 13.1411C13.4047 12.4086 14.0001 11.2738 14.0001 10C14.0001 7.79086 12.2093 6 10.0001 6C7.79098 6 6.00012 7.79086 6.00012 10C6.00012 11.2738 6.59557 12.4086 7.52331 13.1411C7.79253 13.3537 7.98463 13.6597 7.99923 14H12.001Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDifficult);
export default __webpack_public_path__ + "static/media/icon_difficult.1ee800571c66e5ef4a84f33f2a0529a2.svg";
export { ForwardRef as ReactComponent };